// frontend/src/components/detail/EntityHeader.jsx
import React from 'react';
import { Box, Typography, IconButton, Stack, Tooltip, Switch } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useLocation } from 'react-router-dom';

export default function EntityHeader({
  title,
  TileComponent,        // e.g., JobTile
  tileProps,            // props your tile expects (identical to dashboard usage)
  onBackPath = '/dashboard',
  receiptsEnabled,
  onToggleReceipts
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const deepLink = React.useMemo(() => {
    const url = new URL(window.location.origin + location.pathname + location.search);
    return url.toString();
  }, [location.pathname, location.search]);

  return (
    <Box sx={{ px: 3, pt: 2, pb: 1 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <IconButton onClick={() => navigate(onBackPath)} size="small">
            <ArrowBackIcon fontSize="small" />
          </IconButton>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>{title}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="body2">Show receipts</Typography>
            <Switch size="small" checked={!!receiptsEnabled} onChange={onToggleReceipts} />
          </Stack>
          <Tooltip title="Open in new tab">
            <IconButton onClick={() => window.open(deepLink, '_blank', 'noopener')} size="small">
              <OpenInNewIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>

      {/* The tile rendered full-width, identical visuals to dashboard */}
      <Box sx={{ maxWidth: 980, mt: 1 }}>
        {TileComponent ? <TileComponent {...tileProps} /> : null}
      </Box>
    </Box>
  );
}
